module.exports = __webpack_public_path__ + "img/teaWeb0.f4969f35.png";